import { render, staticRenderFns } from "./AppStart.vue?vue&type=template&id=185ee710&scoped=true&"
var script = {}
import style0 from "./AppStart.vue?vue&type=style&index=0&id=185ee710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185ee710",
  null
  
)

export default component.exports